export default "/assets/lesson_card-4ae163907dc62792915cadce0bccdcd8bb672c8fe48e778c751ef8530afebb24.svg";